import { Controller } from "@hotwired/stimulus"
import { Sortable } from "sortablejs"

export default class extends Controller {
  static targets = ["folder", "item", "lockButton", "unlockButton"]
  initialize() {
    this.sortableInstances = []
  }
  connect() {
    if (this.hasItemTarget) {
      this.folderTargets.forEach((folder) => {
        const sortable = new Sortable(folder, {
          draggable: "li",
          group: "shared",
          animation: 250,
          delay: 75,
          delayOnTouchOnly: true,
          ghostClass: "border-2",
        })
        this.sortableInstances.push(sortable)
      })
    }
  }

  lockDraggable() {
    this.sortableInstances.forEach((sortable) => {
      sortable.option("disabled", true)
    })
    this.lockButtonTarget.classList.add("hidden")
    this.unlockButtonTarget.classList.remove("hidden")
  }

  unlockDraggable() {
    this.sortableInstances.forEach((sortable) => {
      sortable.option("disabled", false)
    })
    this.unlockButtonTarget.classList.add("hidden")
    this.lockButtonTarget.classList.remove("hidden")
  }

  disconnect() {}
}
